import PropTypes from 'prop-types'

export default {
    api_url: PropTypes.string,
    socket_url: PropTypes.string,
    file_url: PropTypes.string,
    sync_url: PropTypes.string,
    ntp_url: PropTypes.string,
    file_auth: PropTypes.string,
    store_sync: PropTypes.string,
    store_code: PropTypes.string,
    layer_enabled: PropTypes.string,
    layer_extra: PropTypes.string,
    volume: PropTypes.string,
    selected_channel: PropTypes.string,
    background_colour: PropTypes.string,
    sync_delay: PropTypes.string,
    sync_offset: PropTypes.string,
    sync_timeout: PropTypes.string,
    screen_rotation: PropTypes.string,
    working_close: PropTypes.string,
    working_open: PropTypes.string,
    device_owner: PropTypes.string,
    key_wifi_networks: PropTypes.string,
    apk_version: PropTypes.string,
    selected_type: PropTypes.string,
    disable_zoom: PropTypes.string,
    filter_level: PropTypes.string,
    antenna_level: PropTypes.string,
    four_k: PropTypes.string,
    auth_key: PropTypes.string,
    store_location: PropTypes.string,
}
